import { FinanceTransferStatus } from "@/features/finance/model/finance-types"
import { useFinanceTransferRequestsQuery } from "@/features/finance/services/finance-query"

/**
 * How many transfers are waiting for THIS branch to decide.
 *
 * Incoming and PENDING — the transfers whose money is held somewhere else until someone here accepts or
 * refuses them. Outgoing pending transfers are deliberately excluded: they are waiting on the far branch, and
 * badging the sender for them would mark work nobody here can do.
 *
 * Applies to the parish exactly as to a branch. The parish is the destination of most remittances, so it is
 * the context where an unnoticed queue costs the most.
 */
export function usePendingIncomingTransfersCount(
  workspaceId: string | null | undefined,
  branchId: string | null | undefined,
): number {
  const query = useFinanceTransferRequestsQuery(
    workspaceId && branchId
      ? {
          workspaceId,
          destinationBranchId: branchId,
          status: FinanceTransferStatus.Pending,
          // Only the count is wanted, and the list endpoint reports the unpaginated total — so one row is
          // enough to learn it, rather than pulling a page of records the sidebar never renders.
          page: 1,
          limit: 1,
        }
      : null,
  )

  return query.data?.total ?? 0
}
